import React from 'react'
import { Button, Select, Typography } from '@telavita-core/react-design-kit'

import * as S from './styles'

interface Approach {
  name: string
  code: string
}

interface ProfessionalTherapyApproachFilterProps {
  approaches: Approach[]
  selectedApproach: string
  onChangeApproach: (value: Approach) => void
  openTherapyApproachModal: () => void
}

export const ProfessionalTherapyApproachFilter: React.FC<ProfessionalTherapyApproachFilterProps> = ({ 
  approaches, 
  selectedApproach, 
  onChangeApproach,
  openTherapyApproachModal
}) => {

  const formatSelectedApproachToValidOption = (code: string) => {
    const approach = approaches.find(approach => approach.code === code)
    return approach ? {
      id: approach.code,
      label: approach.name
    } : null
  }

  const formattedApproaches = [{ name: 'Todas', code: '' }, ...approaches].map(approach => ({
    id: approach.code,
    label: approach.name
  }))

  const selectedAllApproachesAsDefaultOption = formattedApproaches.find(approach => approach.label === 'Todas')

  return (
    <S.ApproachContainer>
      <S.ApproachWrapper>
        <Typography
          variant='content2'
          weight='bold'
        >
          Abordagem terapêutica
        </Typography>
        <Button 
          variant='text' 
          color='primary'
          uppercase={false}
          onClick={openTherapyApproachModal}
        >
          O que é?
        </Button>
      </S.ApproachWrapper>

      <Select 
        label=''
        options={formattedApproaches}
        selected={
          !selectedApproach 
            ? selectedAllApproachesAsDefaultOption
            : formatSelectedApproachToValidOption(selectedApproach)
        }
        onSelect={({id, label}) => onChangeApproach({ code: String(id), name: label })}
        customClassName="therapyApproachSelect"
      />
    </S.ApproachContainer>
  )
}